// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2520849c","450":"dea9c1ad","453":"40a8f5bb"}[chunkId] + ".chunk.js";
};